import request from '@/utils/request'


export function addUvFile(data) {
    return request({
        url: `api/serviceCenter/uvFile/addUvFile`,
        method: 'post',
        data,
    })
}

export function upDateUvFile(data) {
    return request({
        url: `api/serviceCenter/uvFile/upDateUvFile`,
        method: 'post',
        data,
    })
}

export function UvFileSelectInfo(currentPage,pageSize,data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/uvFile/UvFileSelectInfo?size=${pageSize}&current=${currentPage}`,
        method: 'post',
        data,
    })
}

export function bathDeleteFile(data) {
    return request({
        url: `api/serviceCenter/uvFile/bathDeleteFile`,
        method: 'post',
        data,
    })
}
export function uvSelectPanel(data) {
    return request({
        url: `api/serviceCenter/miniUpload/uvSelectPanel`,
        method: 'post',
        data,
    })
}






